import './App.css';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Menu from './components/Menu';
import DjehootyDocument from './models/document';
import Loader from './components/Loader';
import { Toaster } from 'react-hot-toast';

// Lazy load components using React.lazy
const Help = lazy(() => import('./pages/help'));
const DocumentList = lazy(() => import('./pages/document-list'));
const ImportPage = lazy(() => import('./pages/import'));
const DocumentBrowser = lazy(() => import('./pages/document'));
const IndividualList = lazy(() => import('./pages/individual-list'));
const IndividualViewer = lazy(() => import('./pages/individual'));
const PageNotFound = lazy(() => import('./pages/not-found'));

// Fallback UI component to show while lazy-loaded component is loading
const FallbackLoader = () => {

  return (
    <div className="flex flex-col w-full h-full overflow-hidden">
      <div className="flex flex-row items-center flex-shrink-0 m-2 mb-4 gap-x-2">
        <Loader
          message="Loading page content..."
          subtitle={true} />
      </div>
    </div>
  );
}

/**
 * Main application component that handles routing and layout structure.
 * Implements lazy loading for performance optimization and provides
 * accessible navigation structure.
 */
function App() {
  return (
    <div className="App ">
      <BrowserRouter>
        <div className="flex flex-row h-screen overflow-hidden">
          <aside
            className="w-64 flex-shrink-0 h-screen flex-col justify-between border-e border-gray-100 bg-white"
            role="navigation"
            aria-label="Main navigation"
          >
            <Menu />
          </aside>
          <main
            className="flex-1 p-2 h-screen box-border overflow-hidden"
            role="main"
            aria-label="Main content"
          >
            <Suspense
              fallback={<FallbackLoader />}
            >
              <Routes>
                <Route path="/" element={<Navigate to="/documents" replace />} />
                <Route path="/help" element={<Help />} />
                <Route path="/documents" element={<DocumentList fetchFunction={DjehootyDocument.fetchAll} />} />
                <Route path="/import" element={<ImportPage />} />
                <Route path="/documents/:id" element={<DocumentBrowser />} />
                <Route path="/individuals" element={<IndividualList />} />
                <Route path="/individuals/:individualID" element={<IndividualViewer />} />
                <Route path="*" element={<PageNotFound />} />
              </Routes>
            </Suspense>
            <Toaster
              position="bottom-right"
              reverseOrder={true}
              toastOptions={{
                success: {
                  duration: 3000,
                  style: {
                    backgroundColor: '#dbeafe',
                  },
                },
                loading: {
                  style: {
                    backgroundColor: '#dbeafe',
                  },
                },
                error: {
                  duration: 10000,
                  style: {
                    backgroundColor: '#FFFAF0',
                  },
                },
              }}
            />
          </main>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
